import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { AppCtxComponent } from 'js/reactAppCtx';
import { DesAccConstants } from '../constant/desAccConstants';
import DesFileUploadSampleViewModel from 'viewmodel/DesFileUploadSampleViewModel';

/**
 * File upload sample component.
 */
export default class DesFileUploadSample extends HTMLElement {
    constructor() {
        super();
        this.debounceTimer = 100;
        this.ViewModel = DesFileUploadSampleViewModel;
    }

    get locale() {
        return this.getAttribute(DesAccConstants.LOCALE) || 'en_US';
    }

    getProps() {
        return {};
    }

    connectedCallback() {

    }
    createReactElement() {
        return React.createElement(
            this.ViewModel,
            {
                accsessionid: this.getAttribute(DesAccConstants.ACC_SESSION_ID),
                collaborationspaceid: this.getAttribute(DesAccConstants.COLLABORATION_SPACE_ID),
                libraryid: this.getAttribute(DesAccConstants.CONTAINER_ID),
                ...this.getProps()
            },
            React.createElement('slot')
        );
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (oldValue !== newValue) {
            this.debounceCreateElement();
        }
    }
    debounceCreateElement() {
        const _this = this;
        if (_this.debounceFuncRef) {
            clearTimeout(_this.debounceFuncRef);
        }

        _this.debounceFuncRef = setTimeout(() => {
            ReactDOM.render(<AppCtxComponent>{_this.createReactElement()}</AppCtxComponent>, _this);
        }, this.debounceTimer);
    }
    static get observedAttributes() {
        return [
            DesAccConstants.ACC_SESSION_ID,
            DesAccConstants.COLLABORATION_SPACE_ID,
            DesAccConstants.CONTAINER_ID,
        ];
    }
}

if (!window.customElements.get('des-file-upload-sample')) {
    window.customElements.define('des-file-upload-sample', DesFileUploadSample);
}
